export const GET_SURAHPENDEKGURU_SUCCEED = "surahpendekguru/get/succeed";
export const GET_SURAHPENDEKGURU_REQUEST = "surahpendekguru/get/request";
export const GET_SURAHPENDEKGURU_FAILED = "surahpendekguru/get/failed";

export const GET_SURAHPENDEKGURUAWAL_SUCCEED =
  "surahpendekguru/getawal/succeed";
export const GET_SURAHPENDEKGURUAWAL_REQUEST =
  "surahpendekguru/getawal/request";
export const GET_SURAHPENDEKGURUAWAL_FAILED = "surahpendekguru/getawal/failed";

export const CREATE_SURAHPENDEKGURU_REQUEST = "surahpendekguru/create/request";
export const CREATE_SURAHPENDEKGURU_SUCCEED = "surahpendekguru/create/succeed";
export const CREATE_SURAHPENDEKGURU_FAILED = "surahpendekguru/create/failed";

export const DELETE_SURAHPENDEKGURU_REQUEST = "surahpendekguru/delete/request";
export const DELETE_SURAHPENDEKGURU_SUCCEED = "surahpendekguru/delete/succeed";
export const DELETE_SURAHPENDEKGURU_FAILED = "surahpendekguru/delete/failed";

export const GET_BY_ID_SURAHPENDEKGURU_REQUEST =
  "surahpendekguru/getid/request";
export const GET_BY_ID_SURAHPENDEKGURU_SUCCEED =
  "surahpendekguru/getid/succeed";
export const GET_BY_ID_SURAHPENDEKGURU_FAILED = "surahpendekguru/getid/failed";

export const GET_BY_RUMAHTAHFIDZ_SURAHPENDEKGURU_REQUEST =
  "surahpendekguru/getrumahtahfidz/request";
export const GET_BY_RUMAHTAHFIDZ_SURAHPENDEKGURU_SUCCEED =
  "surahpendekguru/getrumahtahfidz/succeed";
export const GET_BY_RUMAHTAHFIDZ_SURAHPENDEKGURU_FAILED =
  "surahpendekguru/getrumahtahfidz/failed";

export const GET_BY_MASTERTAHFIDZ_SURAHPENDEKGURU_REQUEST =
  "surahpendekguru/getbymastertahfidz/request";
export const GET_BY_MASTERTAHFIDZ_SURAHPENDEKGURU_SUCCEED =
  "surahpendekguru/getbymastertahfidz/succeed";
export const GET_BY_MASTERTAHFIDZ_SURAHPENDEKGURU_FAILED =
  "surahpendekguru/getbymastertahfidz/failed";

export const UPDATE_SURAHPENDEKGURU_REQUEST = "surahpendekguru/update/request";
export const UPDATE_SURAHPENDEKGURU_SUCCEED = "surahpendekguru/update/succeed";
export const UPDATE_SURAHPENDEKGURU_FAILED = "surahpendekguru/update/failed";
